import { render, staticRenderFns } from "./medicalSms.vue?vue&type=template&id=c7abc958&scoped=true&"
import script from "./medicalSms.vue?vue&type=script&lang=js&"
export * from "./medicalSms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7abc958",
  null
  
)

export default component.exports